import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoadingBarHttpModule } from '@ngx-loading-bar/http';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { TiersModule } from './tiers/tiers.module';
import { HttpServiceProvider } from './http.service.provider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth-interceptor.service';
import { NoContentComponent } from './no-content/no-content.component';
import { NavigationComponent } from './navigation/navigation.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { GrowlModule } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { MessagesComponent } from './messages/messages.component';
import { BaseService } from './base.service';
import { OrganisationsService } from './services/organisations.service';
import { CustomInputModule } from './components/input/custom-input.module';
import { DistributorsModule } from './distributors/distributors.module';
import { PostcodesModule } from './postcodes/postcodes.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuComponent } from './menu/menu.component';
import { InvoicesModule } from './invoices/invoices.module';
import { OrganisationResolver } from './resolvers/organisation.resolver';
import { BreadcrumbService } from './breadcrumb/breadcrumb.service';
import { CustomPipesModule } from './pipes/custom-pipes.module';
import {GroupRightService} from './services/group-right.service';
import {GroupRightsResolver} from './resolvers/group-rights.resolves';
import {ProductKindService} from './services/product-kind.service';
import {ProductKindResolver} from './resolvers/product-kind.resolver';

@NgModule({
	declarations: [
		AppComponent,
		NoContentComponent,
		NavigationComponent,
		BreadcrumbComponent,
		MenuComponent,
		MessagesComponent
	],
	imports: [
		AppRoutingModule,

		TiersModule,
		DistributorsModule,
		PostcodesModule,
		InvoicesModule,
		CustomInputModule,
		CustomPipesModule,

		BrowserModule,
		FormsModule,
		HttpModule,
		HttpClientModule,
		RouterModule,
		LoadingBarHttpModule,
		LoadingBarHttpClientModule,
		LoadingBarRouterModule,

		GrowlModule,
		BrowserAnimationsModule,
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		HttpServiceProvider,
		MessageService,
		BreadcrumbService,
		OrganisationsService,
		OrganisationResolver,
		GroupRightService,
		GroupRightsResolver,
		ProductKindService,
		ProductKindResolver,
		BaseService,
		Title
	],
	bootstrap: [AppComponent]
})
export class AppModule
{
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts